import { useEffect, useRef, useState } from "react";

const NavbarPC = () => {
  const navRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 800) {
        setIsScrolled(window.scrollY > 50);
      } else {
        setIsScrolled(false); // 800px 이하에서는 항상 보이도록 설정
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // 🟢 특정 이미지 위치로 스크롤 (50px 위로 조정)
  const handleScrollToImage = (pcImageId, mobileImageId) => {
    const isMobile = window.innerWidth <= 1100;
    const targetId = isMobile ? mobileImageId : pcImageId;
    const target = document.getElementById(targetId);

    if (target) {
      const offset = isMobile ? 110 : 80; // 🟢 모바일이면 -120px 추가 보정
      const targetPosition =
        target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <nav ref={navRef} className="navbar">
      <div
        className={`logo ${isScrolled ? "hide" : "show"}`}
        onClick={() => {
          window.location.href = "http://eplusdentistry.com/";
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/image/${
            window.innerWidth <= 800 ? "mo/moHeader.png" : "pc/pcHeader.png"
          }`}
          alt="이플러스치과 로고"
        />
      </div>
      <ul className={`menu ${isScrolled ? "move-up" : ""}`}>
        <li onClick={() => handleScrollToImage("image-2", "image-2")}>
          이플러스치과의 특별함
        </li>

        <li onClick={() => handleScrollToImage("image-3", "image-3")}>
          진료안내
        </li>
        {!isMobile && (
          <li onClick={() => handleScrollToImage("image-4", "image-4")}>
            임플란트
          </li>
        )}
        <li onClick={() => handleScrollToImage("image-9", "image-4")}>
          의료진소개
        </li>
        <li onClick={() => handleScrollToImage("image-12", "image-10")}>
          진료시간 & 오시는 길
        </li>
      </ul>
      {/* 1100까진 괜찮네 */}
      <style jsx>{`
        .navbar {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 80px;
          background-color: white;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1000;
          transition: all 0.5s ease;
        }

        .logo {
          padding: 22px 0 22px;
          background-color: white;
          transition: opacity 0.5s ease, transform 0.5s ease;
        }

        .hide {
          opacity: 0;
          transform: translateY(-20px);
          pointer-events: none; /* 사라졌을 때 클릭 방지 */
        }

        .show {
          opacity: 1;
          transform: translateY(0);
        }

        .menu {
          display: flex;
          justify-content: center;
          align-items: center;
          list-style: none;
          gap: 5.72%;
          padding: 0;
          height: 80px;
          width: 100%;
          font-size: clamp(16px, 2vw, 25px);
          font-weight: 500;
          font-family: "Pretendard";
          transition: transform 0.7s ease, top 0.5s ease;
          position: absolute;
          top: calc(6.16vw - 4.21%);
          background-color: white;
          z-index: 10;
        }

        .move-up {
          margin: 0;
          top: 0px; /* 로고가 사라진 후 위로 이동 */
        }

        .menu li {
          cursor: pointer;
        }

        .menu li:hover {
          text-decoration: underline;
        }

        @media (max-width: 800px) {
          .navbar {
            height: 50px;
          }
          .menu {
            white-space: nowrap;
            padding-top: 5px;
            height: 20px;
            font-size: 3.1vw;
            gap: 0.5vw;
            font-weight: 700;
            top: calc(80px + (100vw - 352px) * 0.1);
          }

          .menu li {
            padding: 0 1vw 0 0.5vw;
            border-right: 1px solid black;
          }
        }
        /* 🟢 500px 이하: top을 더 줄이도록 조정 */
        @media (max-width: 500px) {
          .menu {
            top: calc(70px + (100vw - 352px) * 0.09);
          }
        }
        /* 🟢 400px 이하: top을 더 줄이도록 조정 */
        @media (max-width: 400px) {
          .menu {
            top: calc(70px + (100vw - 352px) * 0.01);
          }
        }

        /* 🟢 350px 이하: top을 더 줄임 */
        @media (max-width: 350px) {
          .menu {
            top: calc(65px + (100vw - 320px) * 0.02);
          }
        }

        /* 🟢 300px 이하: 고정값 적용 */
        @media (max-width: 300px) {
          .menu {
            top: 57px;
          }
        }
      `}</style>
    </nav>
  );
};

export default NavbarPC;
